<template>
  <router-view/>
</template>
<style lang="scss">
#app, #qianliu-doctor-app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  height: 100%;
}
</style>